//! PLEASE keep this list in alphabetical order for a better readability
export enum DISTRIBUTE {
    /**
     * @value Distribute
     * @description Action verb used as a from prefix to let the user know that she's about to "distribute" a resource to some users: "Distribute • <name of the resource>"
     */
    DISTRIBUTE = 'BROADCASTS.DISTRIBUTE',
    /**
     * @value Distributed
     * @description Label of a notification to let the user know that "something has been distributed"
     */
    DISTRIBUTED = 'CONTENTS.DISTRIBUTED',
    /**
     * @value Distribute content
     */
    DISTRIBUTE_CONTENT = 'DISTRIBUTE.DISTRIBUTE_CONTENT',
    /**
     * @value Distribution scheduled
     * @description Label of a notification letting the user know that the distribution of something has been planned successfully
     */
    DISTRIBUTION_SCHEDULED = 'CONTENTS.DISTRIBUTION_SCHEDULED',
    /**
     * @value To increase the visibility of this content, you can now promote it.
     * @description Text of a notification letting the user know what she can do once her piece of content has been published
     */
    NOTIFICATION_DISTRIBUTE_CONTENT_DESCRIPTION = 'CONTENTS.CONTENT_PUBLISHED_NOTIFICATION_DESCRIPTION',
}
